export enum TicketStatus {
    CREATED = 'Created',
    PAID = 'Paid',
    WAIVED = 'Waived',
}

export type Ticket = {
    uuid: string;
    code: string;
    image_url: string;
    status: TicketStatus;
    amount: number;
    evaluated_amount: number;
    plate: string;
    state: string;
    spot_name: string;
    google_maps_url: string;
    created_at: string;
    is_first_time_offense: boolean;
};
